(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PhotoIbqDetailController', PhotoIbqDetailController);

    PhotoIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Photo', 'MusicalPiece', 'Person'];

    function PhotoIbqDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Photo, MusicalPiece, Person) {
        var vm = this;

        vm.photo = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:photoUpdate', function(event, result) {
            vm.photo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
